import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IFair } from "../types/seed";

const API = process.env.REACT_APP_API;

const useUpdateCurrentFairWindow = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ openAt, closeAt }: { openAt: string; closeAt: string }) => {
      return fetch(`${API}/api/semeadora/fairs/current/window/`, {
        method: "PATCH",
        body: { open_at: openAt, close_at: closeAt },
      }) as Promise<IFair>;
    },
    onError: (error) => {
      console.log("onError", error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fair"] });
    },
  });
};

export default useUpdateCurrentFairWindow;
